import { container } from "tsyringe";
import { ManagementLoginApprovalApiRepository } from "../../repositories/api/ManagementLoginApprovalApiRepository";
import ApiService from "../../services/ApiService";
import { ManagementLoginApprovalMapper } from "@/data/persistences/mappers/ManagementLoginApprovalMapper";
import { ManagementLoginApprovalEndpoint } from "../../endpoints/ManagementLoginApprovalEndpoint";
import { ManagementLoginApprovalPresenter } from "@/app/ui/presenters/ManagementLoginApprovalPresenter";

export class ManagementLoginApprovalComponent {
  public static init() {
    container.register<ManagementLoginApprovalApiRepository>(
      ManagementLoginApprovalApiRepository,
      {
        useFactory: (d) => {
          return new ManagementLoginApprovalApiRepository(
            d.resolve(ApiService),
            d.resolve(ManagementLoginApprovalMapper),
            d.resolve(ManagementLoginApprovalEndpoint)
          );
        }
      }
    );
    container.register<ManagementLoginApprovalMapper>(
      ManagementLoginApprovalMapper,
      {
        useClass: ManagementLoginApprovalMapper
      }
    );
    container.register(ManagementLoginApprovalPresenter, {
      useFactory: (d) => {
        return new ManagementLoginApprovalPresenter(
          d.resolve(ManagementLoginApprovalApiRepository)
        );
      }
    });
  }
}
